import { useOutletContext } from 'react-router-dom';
import SlowestRoutesTable from './components/SlowestRoutesTable';

const SlowestRoutesTab = () => {
  const { slowest_routes } = useOutletContext();
  return <SlowestRoutesTable data={slowest_routes} />;
};

export default SlowestRoutesTab;
